export default "__VITE_ASSET__CCfZ5tm6__"